module.exports = __webpack_public_path__ + "img/panele.55ede909.jpg";